import { render, staticRenderFns } from "./DialogAddExtract.vue?vue&type=template&id=10f523f7"
import script from "./DialogAddExtract.vue?vue&type=script&lang=js"
export * from "./DialogAddExtract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports